// src/config/analytics.js
export const ANALYTICS_CONFIG = {
  measurementId: 'G-JSXPY1887B',
  domains: [
    'vaidhyamegha.com',
    'dev-vaidhyamegha.web.app',
    'csdlc.org',
    'csdlc.ai',
    'aisdlc.com',
    'samyama.ai',
    'dev.samyama.ai'
  ],
  cookieFlags: 'SameSite=None;Secure',
  debug: false, // Set to true only for testing
  allowLinker: true,
  crossDomainCategories: {
    CSDLC: 'csdlc_interaction',
    CSDLC_AI: 'csdlc_ai_interaction',
    AISDLC: 'aisdlc_interaction'
  }
};
